import { render } from "./Skeleton.vue?vue&type=template&id=7b736b6e&scoped=true"
import script from "./Skeleton.vue?vue&type=script&lang=js"
export * from "./Skeleton.vue?vue&type=script&lang=js"

import "./Skeleton.vue?vue&type=style&index=0&id=7b736b6e&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b736b6e"]])

export default __exports__